module.exports = {
  "login": {
    login: "登录",
    loginHint: "欢迎来到AI心理测评云平台",
    account: "账号",
    "accountHint": "请输入账号",
    "password": "密码",
    "passwordHint": "请输入密码",
    "agreementHint": "我已阅读并同意",
    "serviceAgreement": "用户协议",
    "privacyAgreement": "隐私政策",
    childProtection: "儿童隐私保护政策",
    "userPrivacyPolicyHint": "请先仔细阅读并同意《用户协议》和《隐私政策》和《儿童隐私保护政策》",
  },
}



// WEBPACK FOOTER //
// ./src/i18n/login/zh-CN.js